/**
 * Browser Sentry is loaded once the main thread is idle so the SDK (~85 KB gz) stays out of
 * every route's first-load JS. Errors thrown before it loads are not captured client-side.
 * Without NEXT_PUBLIC_SENTRY_DSN the SDK is never downloaded.
 */
import { onCatchUpComplete } from "@/lib/realtime/catchUpEvents";
import { onResume, RESUME_REFETCH_AWAY_MS } from "@/lib/realtime/resumeCoordinator";
import { initServiceWorkerUpdateOnResume } from "@/lib/realtime/serviceWorkerResumeUpdate";
import { recordCatchUp, recordResume } from "@/lib/observability/perfMetrics";

let sentry = null;

if (typeof window !== "undefined") {
  onResume(({ awayMs, trigger }) => {
    if (awayMs > RESUME_REFETCH_AWAY_MS) recordResume(awayMs, trigger);
  });
  initServiceWorkerUpdateOnResume();
  onCatchUpComplete(recordCatchUp);
  if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
    const load = () => {
      import("@/lib/observability/sentryBrowser")
        .then((mod) => {
          sentry = mod;
        })
        .catch(() => {});
    };
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(load, { timeout: 4000 });
    } else {
      setTimeout(load, 2000);
    }
  }
}

export function onRouterTransitionStart(...args) {
  sentry?.captureRouterTransitionStart?.(...args);
}
